module.exports = __webpack_public_path__ + "img/背景3.f2ab25f4.jpg";